import { format } from "date-fns";
import React, { useState, useEffect } from "react";
import { DOCTOR_ROLE } from "../constants";
import {
  MASTER_LOCATION_DATA_LOCATION_KEY,
  PATIENT_VISIT_TYPE,
  PAYMENT_MODE_NORMALIZER,
} from "../../core/constants/erpConstants";

function getDate(date) {
  console.log("Helper -Date", date);
  var dateinfo = new Date(date);
  var finalDate = new Date(
    dateinfo.getTime() + dateinfo.getTimezoneOffset() * 60000,
  );
  //console.log("Helper--",finalDate.toLocaleDateString())
  return finalDate.toLocaleDateString();
}

function formatDate(d) {
  console.log("H-Date", d);
  let date = new Date(d);
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  var h = date.getHours();
  var m = date.getMinutes();
  var s = date.getSeconds();
  var newDate = yyyy + "-" + mm + "-" + dd + " " + h + ":" + m + ":" + s;
  //2021-06-01 07:03:42
  return newDate;
}

function getDateFromTimestamp(d) {
  let date = new Date(d);
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  mm = mm.length === 2 ? mm : "0" + mm;
  var yyyy = date.getFullYear();

  var dt = yyyy + "-" + mm + "-" + dd;
  //2021-06-01 07:03:42
  return dt;
}

const parseDisplayDate = (dateString) => {
  if (!dateString) return null;

  const date = new Date(dateString);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatDateOnly = (dateString, useHyphen = false) => {
  const date = parseDisplayDate(dateString);
  if (!date) return "";

  const separator = useHyphen ? "-" : "/";
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
    .format(date)
    .replace(/\//g, separator);
};

const formatTimeOnly = (dateString) => {
  const date = parseDisplayDate(dateString);
  if (!date) return "";

  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })
    .format(date)
    .toUpperCase();
};

const formatDateNTime = (dateString, useHyphen = false) => {
  const formattedDate = formatDateOnly(dateString, useHyphen);
  const formattedTime = formatTimeOnly(dateString);

  return [formattedDate, formattedTime].filter(Boolean).join(" ");
};

// function getFullName(fname, mname, lname) {
//     var fullName = '';

//     if (!fname || fname == null) { fname = '' }
//     if (!mname || mname == null) { mname = '' }
//     if (!lname || lname == null) { lname = '' }
//     var pfname = fname
//     //console.log("pfname : ",pfname);
//     //   .toLowerCase();
//     var pmname = mname
//     //console.log("pmname : ",pmname);
//     //   .toLowerCase();
//     var plname = lname
//     //console.log("plname : ",plname);
//     //   .toLowerCase();
//     if (pfname == null) { pfname = '' }
//     if (pmname == null) { pmname = '' }
//     if (plname == null) { plname = '' }
//     pfname = pfname.charAt(0).toUpperCase() + pfname.slice(1)
//     pmname = pmname.charAt(0).toUpperCase() + pmname.slice(1)
//     plname = plname.charAt(0).toUpperCase() + plname.slice(1)
//     if (fname && lname) {
//         fullName = pfname + ' ' + plname;
//         //console.log("fullName : ",fullName);
//     } else if (fname && mname) {
//         fullName = pfname + ' ' + pmname;
//         //console.log("fullName : ",fullName);
//     } else if (fname && mname && lname) {
//         fullName = pfname + ' ' + pmname + ' ' + plname;
//         //console.log("fullName : ",fullName);
//     } else {
//         fullName = pfname + "      ";
//         //console.log("fullName : ",fullName);
//     }
//     return fullName;
// }

function getToken() {
  var token = JSON.parse(localStorage.getItem("token"));

  return token;
}

function getServicesAllowed() {
  var servicesAllowed = JSON.parse(localStorage.getItem("services"));

  return servicesAllowed;
}

function getAuthorization() {
  var token = getToken();
  var accessToken = "Bearer ";
  if (token) {
    accessToken = accessToken + token;
  }

  return accessToken;
}

function getCurrentRole() {
  // ROLE_KEYS
}
function getRole() {
  var role = JSON.parse(localStorage.getItem("role"));
  let roles = "";
  console.log("Get role: ", role);

  if (role) {
    // roles = role.split(",");
    if (roles && roles.length > 0) {
      if (roles.indexOf("Admin") !== -1) {
        return "Admin";
      }
    } else if (roles.indexOf("doctor") !== -1) {
      return "doctor";
    } else if (roles.indexOf("serviceDesk") !== -1) {
      return "serviceDesk";
    } else if (roles.indexOf("Nurse") !== -1) {
      return "Nurse";
    }
  }
  return role; //roles[0]
}

function getLoggedUserName() {
  var name = JSON.parse(localStorage.getItem("name"));
  console.log("Logged in User name", name);
  return name;
}

function getLoggedUserGVID() {
  var GVID = JSON.parse(localStorage.getItem("id"));
  console.log("Logged in User ", GVID);
  return GVID;
}

function getLoggedUserID() {
  var userID = JSON.parse(localStorage.getItem("userId"));
  console.log("Logged in User ", userID);
  return userID;
}

function bytesToSize(bytes) {
  var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

//Function for resizing image
function resizeImage(image, max_size) {
  // Resize the image
  var canvas = document.createElement("canvas"),
    //max_size = 544
    width = image.width,
    height = image.height;
  if (width > height) {
    if (width > max_size) {
      height *= max_size / width;
      width = max_size;
    }
  } else {
    if (height > max_size) {
      width *= max_size / height;
      height = max_size;
    }
  }
  canvas.width = width;
  canvas.height = height;
  canvas.getContext("2d").drawImage(image, 0, 0, width, height);
  var dataUrl = canvas.toDataURL("image/jpeg");
  var resizedImage = dataURLToBlob(dataUrl);
  //console.log("ResizedImage",resizedImage)
  return resizedImage;
}

var patientsid = function (patientId) {
  var patientid;
  patientid = patientId;
};

/* Utility function to convert a canvas to a BLOB */
var dataURLToBlob = function (dataURL) {
  var BASE64_MARKER = ";base64,";
  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    var parts = dataURL.split(",");
    var contentType = parts[0].split(":")[1];
    var raw = parts[1];

    return new Blob([raw], { type: contentType });
  }

  //var
  parts = dataURL.split(BASE64_MARKER);
  // var
  contentType = parts[0].split(":")[1];
  //  var
  raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};
/* End Utility function to convert a canvas to a BLOB      */

const readToDisplayImage = (image) => {
  var file = image;
  var reader = new FileReader();
  var url = null;
  // reader.readAsDataURL(file);
  var objurl = URL.createObjectURL(file);
  return objurl;
};
const getFormattedDate = (date) => {
  const reqdate = new Date(date);
  let formatteddate = format(reqdate, "MMM dd yyyy' 'HH:mm");
  return formatteddate;
};

const logout = () => {
  console.log("Clicked on logout ");
  localStorage.clear();
  sessionStorage.clear();
};

const roles = {
  Admin: [
    "PatientForm",
    "Complaints",
    "AssignDoctor",
    "Attachments",
    "BarCode",
    "AllocateRoom",
    "TokenDetails",
    "NonRedeemableVouchers",
  ],
  Admin2: [
    "PatientForm",
    "Complaints",
    "AssignDoctor",
    "Attachments",
    "BarCode",
    "AllocateRoom",
    "TokenDetails",
    "NonRedeemableVouchers",
  ],
  FrontDesk: [
    "PatientForm",
    "Complaints",
    "AssignDoctor",
    "Attachments",
    "BarCode",
    "AllocateRoom",
    "TokenDetails",
    "NonRedeemableVouchers",
  ],
  RegistrationDesk: [
    "PatientForm",
    "Complaints",
    "AssignDoctor",
    "Attachments",
    "BarCode",
    "AllocateRoom",
    "TokenDetails",
    "NonRedeemableVouchers",
  ],
  InsuranceDesk: [
    "PatientForm",
    "Complaints",
    "AssignDoctor",
    "Attachments",
    "BarCode",
    "AllocateRoom",
    "Insurance",
  ],
  ServiceDesk: [
    "PatientForm",
    "Complaints",
    "AssignDoctor",
    "Attachments",
    "BarCode",
    "AllocateRoom",
  ],
  Doctor: ["diagnosis", "PatientForm", "NonRedeemableVouchers"],
};

function getRoles() {
  return roles;
}

const CheckAccessLevel = (access) => {
  let AccessLevel = JSON.parse(localStorage.getItem("AccessLevel"));
  //console.log("AccessLevel",AccessLevel);
  let accessSplit = AccessLevel.split(",");
  //console.log("accessSplit",accessSplit);
  //console.log("sent string is",access);

  let matchedAccess = accessSplit.filter((item) => {
    //    console.log("Itemn is",item);
    if (item === access) {
      //console.log("Itemn inside if",item);
      return true;
    } else {
      return false;
    }
  });
  if (matchedAccess.length > 0) {
    return true;
  } else {
    return false;
  }
};

function rupeeCurrencyFormat(value) {
  return "? " + { value };
}

const getMasterLocationConfigByRole = () => {
  try {
    let mLocConfig = JSON.parse(localStorage.getItem("locConfig"));
    return mLocConfig;
  } catch (error) {
    console.log("Error getMasterLocationConfigByRole :", error);
  }
};

function getFirstLocationIdByKey(masterlocations, locationKey) {
  console.log(
    "cgetFirstLocationIdByKey:masterlocations ",
    locationKey,
    "::",
    masterlocations,
  );

  const location = masterlocations.find(
    (loc) => loc.locationKey === locationKey,
  );

  if (!location) return null;

  try {
    let details = location.locationDetails;

    // Parse only if it's a string (JSON)
    if (typeof details === "string") {
      details = details;
    }

    const firstDetail = details.erpLocationDetails?.[0];
    return firstDetail?.locationid ?? null;
  } catch (e) {
    console.error("Failed to parse locationDetails:", e);
    return null;
  }
}

function getFirstLocationNameByLocationId(masterlocations, locationId) {
  if (!Array.isArray(masterlocations)) {
    return null;
  }
  const location = masterlocations.find(
    (loc) =>
      loc.locationKey != MASTER_LOCATION_DATA_LOCATION_KEY.ALL &&
      loc.locationDetails?.erpLocationDetails?.[0].locationid === locationId,
  );
  if (!location) return null;
  try {
    return location.displayName ?? null;
  } catch (e) {
    console.error("Failed to parse locationDetails:", e);
    return null;
  }
}

const fuzzyFilter = (object, searchText) => {
  const lowerSearch = searchText.toLowerCase();
  console.log("fuzzy filter : ", object, searchText);

  return Object.values(object).some((value) =>
    String(value).toLowerCase().includes(lowerSearch),
  );
};

function roundHalfUpInt(value) {
  return Math.round(Number(value));
}

function getFullName(fname = "", mname = "", lname = "") {
  return [fname, mname, lname].filter(Boolean).join(" ");
}

export function resolveDoctorGvId(doctor, doctorList = []) {
  if (!doctor) return "";

  const directGvId = doctor.gvId ?? doctor.gvid;
  if (directGvId !== undefined && directGvId !== null && directGvId !== "") {
    return directGvId;
  }

  const userId = doctor.userId || doctor.user_id || doctor.userid || doctor.identifier || doctor.value || "";
  if (!userId || !Array.isArray(doctorList) || doctorList.length === 0) {
    return "";
  }

  const matchedDoctor = doctorList.find((item) => {
    const candidateUserId = item?.userId || item?.user_id || item?.userid || item?.identifier || item?.value || "";
    return String(candidateUserId) === String(userId);
  });

  if (!matchedDoctor) return "";

  return matchedDoctor.gvId ?? matchedDoctor.gvid ?? "";
}

export function buildDoctorOption(doc) {
  const firstName = doc.first_name || "";
  const lastName = doc.last_name || "";

  const fullName = helperServices.getFullName(firstName, null, lastName);

  return {
    id: doc.personId,
    value: doc.email,
    role: doc.role || DOCTOR_ROLE,
    department: doc.department,
    firstName: firstName,
    lastName: lastName,
    departmentId: doc.departmentId,
    gvId: doc.gvId,
    gvid: doc.gvId,
    qualification: doc.qualification,
    displayTitle: doc.displaytitle,
    type: doc.type,
    label: `${doc.displaytitle} ${fullName}, Dep of ${doc.department} (${doc.qualification})`,
  };
}

function getLocationIdByvisitType(masterLocationDetails, visitType) {
  let locId = 0;
  if (
    PATIENT_VISIT_TYPE.OUTPATIENT.toLowerCase() === visitType?.toLowerCase()
  ) {
    locId = getFirstLocationIdByKey(
      masterLocationDetails,
      MASTER_LOCATION_DATA_LOCATION_KEY.OP_BILLING,
    );
  } else {
    locId = getFirstLocationIdByKey(
      masterLocationDetails,
      MASTER_LOCATION_DATA_LOCATION_KEY.IP_BILLING,
    );
  }
  return locId;
}


function getBillableLocationIds(masterLocationDetails) {
  if (!Array.isArray(masterLocationDetails) || masterLocationDetails.length === 0) {
    return null;
  }
console.log("getBillableLocationIds",masterLocationDetails);

  const location = masterLocationDetails
    .filter(
      (element) =>
        element?.locationDetails?.erpLocationDetails?.[0]?.isBillingLocation &&
        element?.locationKey !== MASTER_LOCATION_DATA_LOCATION_KEY.ALL
    )
    .map(
      (element) =>
        element?.locationDetails?.erpLocationDetails?.[0]?.locationid
    );

  return location.length > 0 ? location : null;
}

export const getEnableKpCash = (visitType, billingConfig,orgCode) => {
  // safety checks
  if (!billingConfig || !billingConfig.invoiceKpcashKpcreditType) {
    return false;
  }
  if (billingConfig.invoiceKpcashKpcreditType.toLowerCase() === "visittype") {
    if (
      visitType?.toLowerCase() === PATIENT_VISIT_TYPE.INPATIENT.toLowerCase()
    ) {
      return true;
    } else if (
      visitType?.toLowerCase() === PATIENT_VISIT_TYPE.OUTPATIENT.toLowerCase()
    ) {
      return true;
    }
  }
  if (billingConfig.invoiceKpcashKpcreditType.toLowerCase() === "kpcash" && orgCode.toLowerCase() === "manaswini") {
    return true;
  }

  return false;
};


export const mergePaymentModes = (data = []) => {
  return Object.values(
    data.reduce((acc, { name, total }) => {
      const normalizedMode = PAYMENT_MODE_NORMALIZER[name] || name;

      if (!acc[normalizedMode]) {
        acc[normalizedMode] = {
          paymentMode: normalizedMode,
          total: 0,
        };
      }

      acc[normalizedMode].total += Number(total || 0);
      return acc;
    }, {})
  );
};


const helperServices = {
  getDate,
  formatDate,
  formatDateOnly,
  formatDateNTime,
  formatTimeOnly,
  getToken,
  getServicesAllowed,
  getAuthorization,
  getDateFromTimestamp,
  getRole,
  getLoggedUserName,
  getLoggedUserGVID,
  getLoggedUserID,
  resizeImage,
  bytesToSize,
  dataURLToBlob,
  patientsid,
  getFormattedDate,
  getFullName,
  logout,
  readToDisplayImage,
  getRoles,
  CheckAccessLevel,
  rupeeCurrencyFormat,
  getMasterLocationConfigByRole,
  getFirstLocationIdByKey,
  getFirstLocationNameByLocationId,
  fuzzyFilter,
  roundHalfUpInt,
  resolveDoctorGvId,
  buildDoctorOption,
  getLocationIdByvisitType,
  getEnableKpCash,
  mergePaymentModes,
  getBillableLocationIds
};
export default helperServices;
